import {
  Skeleton,
  SkeletonCard,
  SkeletonText,
  SkeletonTitle,
} from '../SkeletonComponents';

/**
 * Skeleton for the Reports tab CONTENT ONLY
 * Used within GroupPageLayout - no header or tabs included
 * Matches: GroupReportsPage (DateRangePicker + View Selector + Report Content)
 */
export function ReportsContentSkeleton() {
  return (
    <div className="space-y-6">
      {/* Date Range Picker - matches DateRangePicker layout */}
      <div className="mb-6">
        <SkeletonText className="w-32 h-4 mb-1" />
        <Skeleton className="w-full h-10 rounded-lg" />
      </div>

      {/* View Selector - matches the view buttons in GroupReportsPage */}
      <div className="mb-6 -mx-4 sm:mx-0">
        <div className="flex justify-center gap-2 overflow-x-auto px-4 sm:px-0 pb-2 sm:pb-0">
          {['Summary', 'Category', 'Members', 'Trends'].map((view, i) => (
            <Skeleton
              key={view}
              className={`px-3 sm:px-4 py-2 rounded-lg min-w-[80px] h-9 ${
                i === 0 ? 'bg-orange-100 dark:bg-orange-900/30' : ''
              }`}
            />
          ))}
        </div>
      </div>

      {/* Report Content - Summary view skeleton (most common view) */}
      <div className="space-y-6">
        {/* Stats Grid - 2x2 grid matching SpendingSummary */}
        <div className="grid grid-cols-2 gap-4">
          {/* Total Spent */}
          <SkeletonCard className="p-4 bg-blue-50 dark:bg-blue-900/20">
            <SkeletonText className="w-24 h-4 mb-2" />
            <SkeletonTitle className="w-32 h-8" />
            <Skeleton className="w-16 h-4 mt-2" />
          </SkeletonCard>

          {/* Average Expense */}
          <SkeletonCard className="p-4 bg-green-50 dark:bg-green-900/20">
            <SkeletonText className="w-28 h-4 mb-2" />
            <SkeletonTitle className="w-28 h-8" />
            <Skeleton className="w-16 h-4 mt-2" />
          </SkeletonCard>

          {/* Total Expenses Count */}
          <SkeletonCard className="p-4 bg-purple-50 dark:bg-purple-900/20">
            <SkeletonText className="w-24 h-4 mb-2" />
            <SkeletonTitle className="w-12 h-8" />
            <Skeleton className="w-16 h-4 mt-2" />
          </SkeletonCard>

          {/* Top Category */}
          <SkeletonCard className="p-4 bg-orange-50 dark:bg-orange-900/20">
            <SkeletonText className="w-24 h-4 mb-2" />
            <div className="flex items-center gap-2">
              <Skeleton className="w-8 h-8 rounded-full" />
              <SkeletonTitle className="w-20 h-6" />
            </div>
            <Skeleton className="w-16 h-4 mt-2" />
          </SkeletonCard>
        </div>

        {/* Top Categories Section */}
        <div>
          <SkeletonTitle className="w-32 h-6 mb-4" />
          <div className="space-y-3">
            {[1, 2, 3].map(i => (
              <div
                key={i}
                className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg"
              >
                <div className="flex items-center gap-3">
                  <Skeleton className="w-10 h-10 rounded-full" />
                  <div>
                    <SkeletonText className="w-24 h-5 mb-1" />
                    <SkeletonText className="w-16 h-3" />
                  </div>
                </div>
                <div className="text-right">
                  <SkeletonTitle className="w-20 h-5 mb-1" />
                  <SkeletonText className="w-12 h-3" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Full page skeleton for Reports page (standalone use)
 * @deprecated Use ReportsContentSkeleton with GroupPageLayout instead
 */
export function ReportsPageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      <ReportsContentSkeleton />
    </div>
  );
}
